import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useEffectOnce } from 'react-use';
import GridPagination from '../GridPagination/GridPagination';
import FullPageGrid from '../ProductGrid/FullPageGrid';
import NoResults from '../ProductGrid/ProductGridNoResults';
import ProductGridContextProvider from '../ProductGridContextProvider';
import { productType } from '../types';

function CategoryGridWrapper({
  categoryDataRefetch = () => {},
  categoryId,
  currentPage,
  espotContent,
  espotIdentifier,
  fullCatHead,
  handleProductCount = () => {},
  isCategoryDataLoading,
  products = [],
  productTotalCount,
  onPaginationButtonClick,
  rows = '90',
  start = '0',
  totalPages,
}) {
  useEffect(() => {
    handleProductCount(productTotalCount);
  }, [productTotalCount, handleProductCount]);
  /**
   * Retry query on client-side if cache-restored server-side query data does not include
   * products. This allows us to bypass orchestration and CDN cache layers, which may
   * have cached stale HTML for this component, e.g., no products.
   */
  useEffectOnce(() => {
    if (!isCategoryDataLoading && !products?.length) {
      categoryDataRefetch({
        skipProductsCache: true,
      });
    }
  });

  return (
    <ProductGridContextProvider>
      <>
        {products.length > 0
          ? (
            <>
              <FullPageGrid
                categoryId={categoryId}
                espotContent={espotContent}
                espotIdentifier={espotIdentifier}
                fullCatHead={fullCatHead}
                products={products}
                shouldSetVisitedProduct
              />
              <GridPagination
                currentPage={currentPage}
                onButtonClick={onPaginationButtonClick}
                rows={rows}
                start={start}
                totalPages={totalPages}
              />
            </>
          )
          : (
            <NoResults />
          )}
      </>
    </ProductGridContextProvider>
  );
}

CategoryGridWrapper.propTypes = {
  // Required props
  categoryId: PropTypes.string.isRequired,
  handleProductCount: PropTypes.func.isRequired,
  onPaginationButtonClick: PropTypes.func.isRequired,
  isCategoryDataLoading: PropTypes.bool.isRequired,
  categoryDataRefetch: PropTypes.func.isRequired,
  productTotalCount: PropTypes.number.isRequired,
  // Optional props
  rows: PropTypes.string,
  start: PropTypes.string,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  fullCatHead: PropTypes.bool,
  espotContent: PropTypes.arrayOf(
    PropTypes.shape({
      espotId: PropTypes.string,
      htmlContent: PropTypes.string,
      timestamp: PropTypes.string,
    }),
  ),
  espotIdentifier: PropTypes.string,
  products: PropTypes.arrayOf(productType),
};

export default CategoryGridWrapper;
